var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const Card = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx("div", Object.assign({ className: `rounded-lg border bg-white text-gray-950 shadow-sm dark:bg-gray-950 dark:text-gray-50 ${className}` }, rest, { children: children })));
};
const CardHeader = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx("div", Object.assign({ className: `flex flex-col space-y-1.5 p-6 ${className}` }, rest, { children: children })));
};
const CardTitle = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx("h3", Object.assign({ className: `text-2xl font-semibold leading-none tracking-tight ${className}` }, rest, { children: children })));
};
const CardContent = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx("div", Object.assign({ className: `p-6 pt-0 ${className}` }, rest, { children: children })));
};
export { Card, CardHeader, CardTitle, CardContent };
export default Card;
